import {drawerAnatomy as parts} from '@chakra-ui/anatomy'
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system'
import {remCalc} from '../../_utils'

// eslint-disable-next-line @typescript-eslint/unbound-method
const {definePartsStyle, defineMultiStyleConfig} = createMultiStyleConfigHelpers(parts.keys)

const filterVariant = definePartsStyle({
    header: {
        display: 'flex',
        flexDir: 'row',
        justifyContent: 'center',
        alignItems: 'flex-end',
        position: 'relative',
        maxWidth: remCalc(414),
        width: '100%',
        padding: {
            base: remCalc(12),
            sm: remCalc(12),
            md: remCalc(20),
            lg: remCalc(20),
        },
        flexShrink: 0,
        color: 'text.default',
        background: 'background.neutral.default',
        borderTopRadius: {
            base: 'unset',
            sm: 'unset',
            md: 'large-1',
            lg: 'large-1',
        },
    },
    overlay: {
        background: 'background.base.overlay',
    },
    dialogContainer: {},
    dialog: {
        background: 'background.neutral.default',
        display: 'flex',
        flexDir: 'column',
        alignItems: 'center',
        // maxHeight (not height) accounts for the top/bottom margins so the box never overflows the viewport
        maxHeight: {
            base: '100%',
            sm: '100%',
            md: `calc(100% - ${remCalc(8)})`,
            lg: `calc(100% - ${remCalc(8)})`,
        },
        marginTop: {
            base: 'unset',
            sm: 'unset',
            md: 'xxxsmall.base',
            lg: 'xxxsmall.base',
        },
        marginBottom: {
            base: 'unset',
            sm: 'unset',
            md: 'xxxsmall.base',
            lg: 'xxxsmall.base',
        },
        marginRight: {
            base: 'unset',
            sm: 'unset',
            md: 'xxxsmall.base',
            lg: 'xxxsmall.base',
        },
        width: {
            lg: remCalc(470),
            md: remCalc(470),
            sm: '100%',
            base: '100%',
        },
        // maxWidth only needs to offset marginRight on md/lg (base/sm has no marginRight)
        maxWidth: {
            lg: remCalc(470),
            md: remCalc(470),
            sm: '100%',
            base: '100%',
        },
        minWidth: {
            lg: remCalc(470),
            md: remCalc(470),
            sm: '100%',
            base: '100%',
        },
        borderRadius: 'large-1',
    },
    closeButton: {
        width: 'iconsSize.medium',
        height: 'iconsSize.medium',
        p: remCalc(4),
    },
    body: {
        background: 'background.neutral.default',
        display: 'flex',
        width: {
            lg: remCalc(470),
            md: remCalc(470),
            sm: '100%',
            base: '100%',
        },
        minWidth: {
            lg: remCalc(470),
            md: remCalc(470),
            sm: '100%',
            base: '100%',
        },
        height: {
            base: '100%',
            sm: '100%',
            md: '100%',
            lg: '100%',
        },
        flexDir: 'column',
        alignItems: 'flex-start',
        gap: 'xsmall-1.base',
        color: 'text.default',
    },
    footer: {
        width: {
            lg: remCalc(470),
            md: remCalc(470),
            sm: '100%',
            base: '100%',
            borderRadius: 'large-1',
        },
        height: remCalc(123),
        display: 'flex',
        flexDir: 'column',
        alignItems: 'flex-start',
        gap: remCalc(11),
        px: remCalc(16),
        py: remCalc(12),
    },
})

export default defineMultiStyleConfig({
    variants: {
        filter: filterVariant,
    },
})
